/** Constantes del sistema relacionadas con almacenamiento y capacidad de recinto. */
export interface Constans {
  /** Días de almacenamiento gratuito. */
  days_off_storage:                 number;
  /** Tarifa de almacenamiento. */
  storage_fee:                      number;
  /** Tarifa especial de almacenamiento. */
  special_storage_rate:             number;
  /** Capacidad del recinto en toneladas. */
  enclosure_capacity_tons:          number;
  /** Capacidad del recinto en metros cuadrados. */
  enclosure_capacity_square_meters: number;
  /** Porcentaje de mermas/abandonos. */
  dropouts_percentage:              number;
}

/** Ubicación (patio) con su identificador y descripciones. */
export interface LocationInterface {
    /** Identificador de la ubicación. */
    id:                number;
    /** Descripción corta de la ubicación. */
    short_description: string;
    /** Descripción de la ubicación. */
    description:       string;
}

/** Ubicación que añade una bandera de deshabilitado para filtros. */
export interface LocationWithFilter extends LocationInterface {
    /** Indica si la ubicación está deshabilitada. */
    disabled: boolean;
}

/** Tipo de empaque con su identificador y descripciones. */
export interface Packaging {
    /** Identificador del empaque. */
    id:                number;
    /** Descripción corta del empaque. */
    short_description: string;
    /** Descripción del empaque. */
    description:       string;
}

/** Grupo de material con su identificador y descripción. */
export interface MaterialGroup {
    /** Identificador del grupo de material. */
    id:          number;
    /** Descripción del grupo de material. */
    description: string;
}

/** Nombre/clave aduanal personalizada. */
export interface CustomName {
    /** Identificador del registro. */
    id:                     number;
    /** Clave del nombre/número aduanal. */
    custom_number_name_key: number;
    /** Descripción del registro. */
    description:            string;
}

/** Material con su identificador, descripciones e identificador SAP. */
export interface Material {
    /** Identificador del material. */
    id:                  string;
    /** Descripción del material. */
    description:         string;
    /** Descripción del material en inglés. */
    description_english: string;
    /** Identificador del material en SAP. */
    sap_id:              string;
}

/** Cliente con su nombre y razón social. */
export interface Customer {
    /** Identificador del cliente. */
    id:            number;
    /** Nombre del cliente. */
    name:          string;
    /** Razón social del cliente. */
    business_name: string;
}

/** Razón social de un cliente con su domicilio. */
export interface CustomerBusinessName {
    /** Identificador de la razón social. */
    id_business_name: number;
    /** Razón social. */
    business_name:    string;
    /** Domicilio de la razón social. */
    address:          string;
}

/** Origen (ubicación) con su identificador y descripciones. */
export interface Origen {
    /** Identificador del origen. */
    id:                number;
    /** Descripción corta del origen. */
    short_description: string;
    /** Descripción del origen. */
    description:       string;
}

/** Registro previo de toma de muestras de un lote. */
export interface PreviousRegistration {
    /** Identificador del registro. */
    id:                      number;
    /** Número de registro del lote. */
    lot_registration_number: number;
    /** Número de oficio. */
    trade_number:            string;
    /** Fecha del muestreo (ISO 8601). */
    sampling_date:           string;
    /** Peso de la muestra. */
    sample_weight:           string;
}

/** Mercancía embargada de un lote con su oficio, fecha, peso y archivo. */
export interface EmbargoedMerchandise {
    /** Identificador del registro. */
    id:                           number;
    /** Número de registro del lote. */
    lot_registration_number:      number;
    /** Número de oficio. */
    trade_number:                 string;
    /** Fecha del oficio (ISO 8601). */
    office_date:                  string;
    /** Peso de la mercancía embargada. */
    weight_embargoed_merchandise: string;
    /** Ruta del archivo soporte. */
    filepath:                     string;
}

/** Cuerpo para identificar el archivo de un lote por registro y número de lote. */
export interface FileBody {
    /** Número de registro del lote. */
    registry_number: number;
    /** Número de lote. */
    lot_number:    number;
}

/** Referencia a un archivo de lote, con URL o contenido en base64. */
export interface FileUrl {
  /** URL para acceder al archivo. */
  url: string;
  /** Contenido del archivo en base64. */
  file_base64?:       string;
  /** Indica si la operación produjo error. */
  error?:          boolean;
  /** Mensaje descriptivo del resultado. */
  message?:        string;
}

/** Identificador de archivo de lote. */
export interface loteFile {
    /** Identificador del lote. */
    id: number;
}

/** Lote consultado con todos sus datos de cliente, material, almacenamiento y tonelajes. */
export interface GetLote {
    /** Identificador del lote de exportación. */
    id_export_batch?:                  number;
    /** Identificador de las salidas de exportación. */
    id_export_outputs?:                number;
    /** Número de registro del lote. */
    registry_number:                   number;
    /** Número de operación. */
    operation_number:                  string;
    /** Identificador del máster. */
    id_master:                         string;
    /** Nombre del barco. */
    ship_name:                         string;
    /** Número de lote del cliente. */
    customer_lot_number:               string;
    /** Identificador del cliente. */
    customer_id:                       number;
    /** Nombre del cliente. */
    client_name:                       string;
    /** Razón social del cliente. */
    business_name_client?:             string;
    /** Identificador de la razón social. */
    id_business_name:                  number;
    /** Fecha de atraque (ISO 8601). */
    docking_date:                      string;
    /** Fecha de desatraque (ISO 8601). */
    undocking_date:                    string;
    /** Identificador del grupo de material. */
    material_group_id:                 number;
    /** Nombre del grupo de material. */
    material_group_name:               string;
    /** Identificador del material. */
    material_id:                       number;
    /** Nombre del material. */
    material_name:                     string;
    /** Identificador del empaque. */
    packing_id:                        number;
    /** Descripción del empaque. */
    packaging:                         string;
    /** Observaciones del lote. */
    observations:                      string;
    /** Tonelaje del lote. */
    tonnage:                           number;
    /** Cantidad de piezas. */
    quantity_pieces:                   number;
    /** Origen de la mercancía. */
    origin:                            string;
    /** Identificador de la ubicación. */
    location_id:                       number;
    /** Días de almacenamiento gratuito. */
    days_free_storage:                 number;
    /** Tarifa de almacenamiento. */
    storage_fee:                       number;
    /** Tarifa especial de almacenamiento. */
    special_storage_rate:              number;
    /** Nombre del consignatario. */
    consignee_name:                    string;
    /** Domicilio del consignatario. */
    address_consignee:                 string;
    /** Valor comercial. */
    commercial_value:                  string;
    /** Bill of lading. */
    bill_lading:                       string;
    /** Embarcador/receptor. */
    shipper_receiver:                  string;
    /** Domicilio del embarcador/receptor. */
    address_shipper_receiver:          string;
    /** Registro de daños o violaciones. */
    damage_violation_record:           string;
    /** Identificación de la mercancía almacenada. */
    identification_stored_merchandise: string;
    /** Volumen ocupado por la mercancía. */
    volume_occupied_merchandise:       number;
    /** Indica si la mercancía está en área fiscalizada. */
    merchandise_fiscalized_area:       boolean;
    /** Toneladas de entrada. */
    input_tons:                        number;
    /** Toneladas de salida. */
    output_tons:                       number;
    /** Toneladas restantes. */
    remaining_tons:                    number;
    /** Nombre de la ubicación. */
    location_name:                     string;
    /** Identificador en SAP. */
    sap_id:                            string;
    /** Identificador del BL del lote. */
    bl_lot_id?:                        string;
    /** Estatus del lote. */
    batch_status?:                     string;
    /** Identificador del BL. */
    bl_id?:                            number;
    /** Indica si la operación produjo error. */
    error?:                            boolean;
    /** Claves/rutas de archivos asociados. */
    keys_files?:                       string[];
    /** Indica si hay rectificación. */
    rectification?:                    boolean;
    /** UUID de la factura asociada. */
    invoice_uuid?:                     string;
}

/** Lote identificado con sus datos principales de cliente, material y almacenamiento. */
export interface LoteId {
    /** Número de registro del lote. */
    registry_number:                   number;
    /** Número de operación. */
    operation_number:                  string;
    /** Identificador del máster. */
    id_master:                         string;
    /** Nombre del barco. */
    ship_name:                         string;
    /** Número de lote del cliente. */
    customer_lot_number:               string;
    /** Identificador del cliente. */
    customer_id:                       number;
    /** Razón social del cliente. */
    business_name_client?:             string;
    /** Identificador de la razón social. */
    id_business_name?:                 number;
    /** Fecha de atraque (ISO 8601). */
    docking_date:                      string;
    /** Fecha de desatraque (ISO 8601). */
    undocking_date:                    string;
    /** Identificador del grupo de material. */
    material_group_id:                 number;
    /** Identificador del material. */
    material_id:                       number;
    /** Identificador del empaque. */
    packing_id:                        number;
    /** Observaciones del lote. */
    observations:                      string;
    /** Tonelaje del lote. */
    tonnage:                           number;
    /** Cantidad de piezas. */
    quantity_pieces:                   number;
    /** Origen de la mercancía. */
    origin:                            string;
    /** Identificador de la ubicación. */
    location_id:                       number;
    /** Días de almacenamiento gratuito. */
    days_free_storage:                 number;
    /** Tarifa de almacenamiento. */
    storage_fee:                       number;
    /** Tarifa especial de almacenamiento. */
    special_storage_rate:              number;
    /** Nombre del consignatario. */
    consignee_name:                    string;
    /** Domicilio del consignatario. */
    address_consignee:                 string;
    /** Valor comercial. */
    commercial_value:                  string;
    /** Bill of lading. */
    bill_lading:                       string;
    /** Embarcador/receptor. */
    shipper_receiver:                  string;
    /** Domicilio del embarcador/receptor. */
    address_shipper_receiver:          string;
    /** Registro de daños o violaciones. */
    damage_violation_record:           string;
    /** Identificación de la mercancía almacenada. */
    identification_stored_merchandise: string;
    /** Volumen ocupado por la mercancía. */
    volume_occupied_merchandise:       string;
    /** Indica si la mercancía está en área fiscalizada. */
    merchandise_fiscalized_area:       boolean;
    /** Nombre del cliente. */
    client_name:                       string;
    /** Nombre del grupo de material. */
    material_group_name:               string;
    /** Nombre del material. */
    material_name:                     string;
    /** Descripción del empaque. */
    packaging:                         string;
    /** Toneladas de entrada. */
    input_tons:                        number;
    /** Toneladas de salida. */
    output_tons:                       number;
    /** Toneladas restantes. */
    remaining_tons:                    number;
    /** Nombre de la ubicación. */
    location_name:                     string;
    /** Domicilio. */
    address:                           string;
    /** Identificador del BL del lote. */
    bl_lot_id?:                        string;
}

/** Lote de importación con datos de cliente, material, almacenamiento, contenedor y CFDI. */
export interface Lote {
    /** Número de lote del cliente. */
    customer_lot_number:                        number;
    /** Identificador del cliente. */
    customer_id:                                number;
    /** Nombre del cliente. */
    client_name:                                string;
    /** Razón social del cliente. */
    business_name_client?:                      string;
    /** Identificador de la razón social. */
    id_business_name?:                          number;
    /** Fecha de atraque (ISO 8601). */
    docking_date:                               string;
    /** Fecha de desatraque (ISO 8601). */
    undocking_date:                             string;
    /** Identificador del grupo de material. */
    material_group_id:                          number;
    /** Nombre del grupo de material. */
    material_group_name:                        string;
    /** Identificador del material. */
    material_id:                                string;
    /** Nombre del material. */
    material_name:                              string;
    /** Identificador del empaque. */
    packing_id:                                 number;
    /** Descripción del empaque. */
    packaging:                                  string;
    /** Observaciones del lote. */
    observations:                               string;
    /** Tonelaje del lote. */
    tonnage:                                    number;
    /** Cantidad de piezas. */
    quantity_pieces:                            number;
    /** Identificador de la ubicación. */
    location_id:                                number;
    /** Días de almacenamiento gratuito. */
    days_free_storage:                          number;
    /** Tarifa de almacenamiento. */
    storage_fee:                                number;
    /** Tarifa especial de almacenamiento. */
    special_storage_rate:                       number;
    /** Nombre del consignatario. */
    consignee_name:                             string;
    /** Domicilio del consignatario. */
    address_consignee:                          string;
    /** Valor comercial. */
    commercial_value:                           number;
    /** Embarcador/receptor. */
    shipper_receiver:                           string;
    /** Domicilio del embarcador/receptor. */
    address_shipper_receiver:                   string;
    /** Registros previos de toma de muestras. */
    previous_registration_sample_collection?:   PreviousRegistrationSampleCollection[];
    /** Registro de daños o violaciones. */
    damage_violation_record:                    string;
    /** Mercancía embargada por aduana. */
    customs_embargoed_merchandise:              CustomsEmbargoedMerchandise[];
    /** Identificación de la mercancía almacenada. */
    identification_stored_merchandise?:         string;
    /** Volumen ocupado por la mercancía. */
    volume_occupied_merchandise:                string;
    /** Indica si la mercancía está en área fiscalizada. */
    merchandise_fiscalized_area:                boolean;
    /** Número PAMA. */
    pama_number:                                string;
    /** Folio fiscal del CFDI. */
    fiscal_folio_cfdi:                          string;
    /** Monto total del CFDI. */
    total_amount_cfdi:                          string;
    /** Monto total de la presentación. */
    total_amount_presentation:                  string;
    /** Monto del depósito de mercancía. */
    amount_merchandise_deposit:                 string;
    /** Monto de compensación. */
    compensation_amount:                        string;
    /** Domicilio. */
    address:                                    string;
    /** Dimensión del contenedor. */
    container_dimension:                        string;
    /** Tipo de contenedor. */
    container_type:                             string;
    /** Número de sellos del contenedor. */
    number_container_seals:                     string;
    /** Número de candados del contenedor. */
    number_container_locks:                     string;
    /** Contenedor sin consolidar. */
    unconsolidated_container:                   string;
    /** Almacén de desconsolidación. */
    deconsolidated_store:                       string;
    /** Medio de transporte sin consolidar. */
    unconsolidated_means_transport:             string;
    /** Contenedor consolidado. */
    consolidated_container:                     string;
    /** Almacén de consolidación. */
    consolidated_store:                         string;
    /** Medio de transporte consolidado. */
    consolidated_means_transport:               string;
    /** Clave/ruta del archivo del BL. */
    file_bl?:                                   string;
}

/** Mercancía embargada por aduana con su oficio, fecha, peso y archivo. */
export interface CustomsEmbargoedMerchandise {
    /** Número de oficio. */
    trade_number:                 string;
    /** Fecha del oficio (ISO 8601). */
    office_date:                  string;
    /** Peso de la mercancía embargada. */
    weight_embargoed_merchandise: number;
    /** Clave/ruta del archivo soporte. */
    file?:                        string;
    /** Ruta del archivo soporte. */
    filepath:                     string;
}

/** Registro previo de toma de muestras con oficio, fecha y peso de muestra. */
export interface PreviousRegistrationSampleCollection {
    /** Número de oficio. */
    trade_number:            string;
    /** Fecha del muestreo (ISO 8601). */
    sampling_date:           string;
    /** Peso de la muestra. */
    sample_weight:           number;
}

/** Respuesta de creación de un lote. */
export interface PostLote {
    /** Número de registro del lote creado. */
    registry_number: number;
    /** Indica si la operación produjo error. */
    error:          boolean;
    /** Mensaje descriptivo del resultado. */
    message:        string;
}

/** Datos para eliminar un lote por operación y registro. */
export interface DeleteLote {
    /** Identificador de la operación. */
    operation_id:    number,
    /** Número de registro del lote. */
    registry_number: number
}

/** Datos para actualizar un lote, con cliente, material, almacenamiento, contenedor y CFDI. */
export interface UpdateLote {
    /** Número de registro del lote. */
    registry_number:                         number;
    /** Número de lote del cliente. */
    customer_lot_number:                     number;
    /** Identificador del cliente. */
    customer_id:                             number;
    /** Nombre del cliente. */
    client_name:                             string;
    /** Razón social del cliente. */
    business_name_client?:                   string;
    /** Identificador de la razón social. */
    id_business_name?:                       number;
    /** Fecha de atraque (ISO 8601). */
    docking_date:                            string;
    /** Fecha de desatraque (ISO 8601). */
    undocking_date:                          string;
    /** Identificador del grupo de material. */
    material_group_id:                       number;
    /** Nombre del grupo de material. */
    material_group_name:                     string;
    /** Identificador del material. */
    material_id:                             string;
    /** Nombre del material. */
    material_name:                           string;
    /** Identificador del empaque. */
    packing_id:                              number;
    /** Descripción del empaque. */
    packaging:                               string;
    /** Observaciones del lote. */
    observations:                            string;
    /** Tonelaje del lote. */
    tonnage:                                 number;
    /** Cantidad de piezas. */
    quantity_pieces:                         number;
    /** Identificador de la ubicación. */
    location_id:                             number;
    /** Días de almacenamiento gratuito. */
    days_free_storage:                       number;
    /** Tarifa de almacenamiento. */
    storage_fee:                             number;
    /** Tarifa especial de almacenamiento. */
    special_storage_rate:                    number;
    /** Nombre del consignatario. */
    consignee_name:                          string;
    /** Domicilio del consignatario. */
    address_consignee:                       string;
    /** Valor comercial. */
    commercial_value:                        number;
    /** Embarcador/receptor. */
    shipper_receiver:                        string;
    /** Domicilio del embarcador/receptor. */
    address_shipper_receiver:                string;
    /** Registros previos de toma de muestras. */
    previous_registration_sample_collection: PreviousRegistrationSampleCollectionUpdate[];
    /** Registro de daños o violaciones. */
    damage_violation_record:                 string;
    /** Mercancía embargada por aduana. */
    customs_embargoed_merchandise:           CustomsEmbargoedMerchandiseUpdate[];
    /** Identificación de la mercancía almacenada. */
    identification_stored_merchandise:       string;
    /** Volumen ocupado por la mercancía. */
    volume_occupied_merchandise:             string;
    /** Indica si la mercancía está en área fiscalizada. */
    merchandise_fiscalized_area:             boolean;
    /** Número PAMA. */
    pama_number:                             string;
    /** Folio fiscal del CFDI. */
    fiscal_folio_cfdi:                       string;
    /** Monto total del CFDI. */
    total_amount_cfdi:                       string;
    /** Monto total de la presentación. */
    total_amount_presentation:               string;
    /** Monto del depósito de mercancía. */
    amount_merchandise_deposit:              string;
    /** Monto de compensación. */
    compensation_amount:                     string;
    /** Domicilio. */
    address:                                 string;
    /** Dimensión del contenedor. */
    container_dimension:                     string;
    /** Tipo de contenedor. */
    container_type:                          string;
    /** Número de sellos del contenedor. */
    number_container_seals:                  string;
    /** Número de candados del contenedor. */
    number_container_locks:                  string;
    /** Contenedor sin consolidar. */
    unconsolidated_container:                string;
    /** Almacén de desconsolidación. */
    deconsolidated_store:                    string;
    /** Medio de transporte sin consolidar. */
    unconsolidated_means_transport:          string;
    /** Contenedor consolidado. */
    consolidated_container:                  string;
    /** Almacén de consolidación. */
    consolidated_store:                      string;
    /** Medio de transporte consolidado. */
    consolidated_means_transport:            string;
}

/** Mercancía embargada (para actualización) con identificador y número de registro del lote. */
export interface CustomsEmbargoedMerchandiseUpdate {
    /** Identificador del registro. */
    id:                           number;
    /** Número de registro del lote. */
    lot_registration_number:      number;
    /** Número de oficio. */
    trade_number:                 string;
    /** Fecha del oficio (ISO 8601). */
    office_date:                  string;
    /** Peso de la mercancía embargada. */
    weight_embargoed_merchandise: number;
    /** Ruta del archivo soporte. */
    filepath:                     string;
}

/** Registro previo de muestras (para actualización) con identificador y número de registro del lote. */
export interface PreviousRegistrationSampleCollectionUpdate {
    /** Identificador del registro. */
    id:                      number;
    /** Número de registro del lote. */
    lot_registration_number: number;
    /** Número de oficio. */
    trade_number:            string;
    /** Fecha del muestreo (ISO 8601). */
    sampling_date:           string;
    /** Peso de la muestra. */
    sample_weight:           number;
}

/** Tipo de entrada con su identificador y descripción. */
export interface TipoEntrada {
    /** Identificador del tipo de entrada. */
    id:          number;
    /** Descripción del tipo de entrada. */
    description: string;
}

/** Puerto nacional con su identificador y descripción. */
export interface NationalPorts {
    /** Identificador del puerto. */
    id:          number;
    /** Descripción del puerto. */
    description: string;
}

/** Datos para crear una entrada de mercancía de un lote. */
export interface EntradaCrear {
    /** Identificador del lote. */
    batch_id:        number;
    /** Identificador del tipo de entrada. */
    input_type_id:   number;
    /** Identificador del estatus del lote. */
    batch_status_id: number;
}

/** Datos para actualizar una entrada de mercancía de un lote. */
export interface EntradaActualizar {
    /** Identificador de la mercancía/entrada. */
    merchandise_id:  number;
    /** Identificador del lote. */
    batch_id:        number;
    /** Identificador del tipo de entrada. */
    input_type_id:   number;
    /** Identificador del estatus del lote. */
    batch_status_id: number;
}

/** Entrada de mercancía de un lote. */
export interface Entrada {
    /** Identificador de la entrada. */
    id:              number;
    /** Identificador del lote. */
    batch_id:        number;
    /** Identificador del tipo de entrada. */
    input_type_id:   number;
    /** Identificador del estatus del lote. */
    batch_status_id: number;
}

/** Elemento de catálogo de tipo de salida. */
export interface SalidaCatalogo {
    /** Identificador del tipo de salida. */
    id:          number;
    /** Descripción del tipo de salida. */
    description: string;
}

/** Salida de mercancía de un lote con datos de transporte, pesaje y aduana. */
export interface Salida {
    /** Tipo de salida (texto auxiliar). */
    tipoSalida?:              string;
    /** Identificador de la opción de tipo de salida. */
    output_type_option_id:    number;
    /** Identificador del máster. */
    id_master:                string;
    /** Identificador del lote. */
    batch_id:                 number;
    /** Número de operación. */
    operation_number:         string;
    /** Clave del precinto. */
    precinct_key:             number;
    /** Número de liberación. */
    release_number:           string;
    /** Identificador del cliente. */
    customer_id:              number;
    /** Identificador de la razón social. */
    id_business_name:         number;
    /** Destino. */
    destination:              string;
    /** Barco asociado. */
    ship:                     string;
    /** Identificador del grupo de material. */
    material_group_id:        number;
    /** Identificador del material. */
    material_id:              number;
    /** Pedimento. */
    petition:                 number;
    /** Identificador de la ubicación. */
    location_id:              number;
    /** Identificador del empaque. */
    packing_id:               number;
    /** Observaciones. */
    observations:             string;
    /** Total de piezas. */
    total_number_pieces:      number;
    /** Tonelaje. */
    tonnage:                  number;
    /** Nombre del checador. */
    checker_name:             string;
    /** Nombre del operador. */
    operator_name:            string;
    /** Identificador del tipo de transporte. */
    transport_type_id:        number;
    /** Línea transportista. */
    transport_line:           string;
    /** Tablas/placas. */
    boards:                   string;
    /** Identificador del tipo de unidad. */
    unit_type_id:             number;
    /** Número de piezas. */
    number_pieces:            number;
    /** Peso bruto. */
    gross_weight:             number;
    /** Peso de tara. */
    tare_weight:              number;
    /** Peso neto. */
    net_weight:               number;
    /** Número de remisión. */
    referral_number:          number;
    /** Agente aduanal. */
    customs_agent:            string;
    /** Fecha de salida (ISO 8601). */
    departure_date:           string;
    /** Hora de salida. */
    departure_time:           string;
    /** Identificador del tipo de salida. */
    output_type_id:           number;
    /** Remisión. */
    remittance:               number;
    /** Factura. */
    bill:                     string;
    /** Muestras de preregistro. */
    pre_registration_samples: string;
    /** Clave/ruta del ticket de báscula. */
    weighbridge_ticket:       string;
    /** Clave/ruta de la orden de transporte. */
    transportation_order:     string;
    /** Lista de pesadas asociadas. */
    weight_list?:              any[];
    /** Clave/ruta de la autorización oficial sin presentación física. */
    official_authorization_physical_presentation?: string;
}

/** Datos de una salida por transferencia, con ubicaciones de origen y destino. */
export interface SalidaTransferencia {
    /** Identificador de la salida. */
    id?:                       number;
    /** Tipo de salida (texto auxiliar). */
    tipoSalida?:               string;
    /** Identificador de la opción de tipo de salida. */
    output_type_option_id:     number;
    /** Identificador del máster. */
    id_master:                 string;
    /** Identificador del lote. */
    batch_id:                  number;
    /** Número de operación. */
    operation_number:          string;
    /** Clave del precinto. */
    precinct_key:              number;
    /** Número de liberación. */
    release_number:            string;
    /** Identificador del cliente. */
    customer_id:               number;
    /** Identificador de la razón social. */
    id_business_name:          number;
    /** Destino. */
    destination:               string;
    /** Barco asociado. */
    ship:                      string;
    /** Identificador del grupo de material. */
    material_group_id:         number;
    /** Identificador del material. */
    material_id:               number;
    /** Identificador del empaque. */
    packing_id:                number;
    /** Observaciones. */
    observations:              string;
    /** Total de piezas. */
    total_number_pieces:       number;
    /** Tonelaje. */
    tonnage:                   number;
    /** Agente aduanal. */
    customs_agent:             string;
    /** Fecha de salida (ISO 8601). */
    departure_date:            string;
    /** Muestras de preregistro. */
    pre_registration_samples:  string;
    /** Clave del recinto destino. */
    destination_enclosure_key: string;
    /** Fecha del movimiento (ISO 8601). */
    movement_date:             string;
    /** Ubicación actual. */
    recent_location:           number;
    /** Ubicación destino. */
    destination_location:      number;
    /** Clave/ruta del documento de orden de traspaso. */
    transfer_order_document:   string;
    /** Folio del traspaso. */
    transfer_folio?:   string;
    /** Clave/ruta del documento de autorización de mermas. */
    autorization_losses_document?:string;
    /** Clave/ruta del documento de mermas. */
    losses_file_document?:         string;
}

/** Datos de una salida sin presentación física (con hoja de modulación). */
export interface SalidaSinPresentacion {
    /** Identificador de la salida. */
    id?:                       number;
    /** Tipo de salida (texto auxiliar). */
    tipoSalida?:              string;
    /** Identificador de la opción de tipo de salida. */
    output_type_option_id:    number;
    /** Identificador del máster. */
    id_master:                string;
    /** Identificador del lote. */
    batch_id:                 number;
    /** Número de operación. */
    operation_number:         string;
    /** Clave del precinto. */
    precinct_key:             number;
    /** Número de liberación. */
    release_number:           string;
    /** Identificador del cliente. */
    customer_id:              number;
    /** Identificador de la razón social. */
    id_business_name:         number;
    /** Destino. */
    destination:              string;
    /** Barco asociado. */
    ship:                     string;
    /** Identificador del grupo de material. */
    material_group_id:        number;
    /** Identificador del material. */
    material_id:              number;
    /** Pedimento. */
    petition:                 number;
    /** Identificador de la ubicación. */
    location_id:              number;
    /** Identificador del empaque. */
    packing_id:               number;
    /** Observaciones. */
    observations:             string;
    /** Total de piezas. */
    total_number_pieces:      number;
    /** Tonelaje. */
    tonnage:                  number;
    /** Nombre del checador. */
    checker_name:             string;
    /** Nombre del operador. */
    operator_name:            string;
    /** Identificador del tipo de transporte. */
    transport_type_id:        number;
    /** Línea transportista. */
    transport_line:           string;
    /** Tablas/placas. */
    boards:                   string;
    /** Identificador del tipo de unidad. */
    unit_type_id:             number;
    /** Número de piezas. */
    number_pieces:            number;
    /** Peso bruto. */
    gross_weight:             number;
    /** Peso de tara. */
    tare_weight:              number;
    /** Peso neto. */
    net_weight:               number;
    /** Número de remisión. */
    referral_number:          number;
    /** Agente aduanal. */
    customs_agent:            string;
    /** Fecha de salida (ISO 8601). */
    departure_date:           string;
    /** Hora de salida. */
    departure_time:           string;
    /** Remisión. */
    remittance:               number;
    /** Factura. */
    bill:                     string;
    /** Clave/ruta de la hoja de modulación. */
    modulation_sheet:         string;
    /** Clave/ruta de la autorización oficial sin presentación física. */
    official_authorization_physical_presentation:       string;
}

/** Respuesta de operaciones sobre una salida. */
export interface SalidaResponse {
    /** Identificador de la salida afectada. */
    id: string | number;
    /** Mensaje descriptivo del resultado. */
    message?: string;
    /** Indica si la operación produjo error. */
    error?: boolean;
}

/** Salida listada con sus datos de transporte, pesaje y estatus del lote. */
export interface SalidaLista {
    /** Identificador de la salida. */
    id:                      number;
    /** Identificador de la opción de tipo de salida. */
    output_type_option_id:    number;
    /** Identificador del máster. */
    id_master:                string;
    /** Identificador del lote. */
    batch_id:                 number;
    /** Número de operación. */
    operation_number:         string;
    /** Clave del precinto. */
    precinct_key:             number;
    /** Número de liberación. */
    release_number:           string;
    /** Identificador del cliente. */
    customer_id:              number | string;
    /** Identificador de la razón social. */
    id_business_name:         number;
    /** Destino. */
    destination:              string;
    /** Barco asociado. */
    ship:                     string;
    /** Identificador del grupo de material. */
    material_group_id:        number;
    /** Identificador del material. */
    material_id:              number;
    /** Pedimento. */
    petition:                 number | string;
    /** Identificador de la ubicación. */
    location_id:              number | string;
    /** Identificador del empaque. */
    packing_id:               number;
    /** Observaciones. */
    observations:             string;
    /** Total de piezas. */
    total_number_pieces:      number;
    /** Tonelaje. */
    tonnage:                  number;
    /** Nombre del checador. */
    checker_name:             string;
    /** Nombre del operador. */
    operator_name:            string;
    /** Identificador del tipo de transporte. */
    transport_type_id:        number;
    /** Línea transportista. */
    transport_line:           string;
    /** Tablas/placas. */
    boards:                   string;
    /** Identificador del tipo de unidad. */
    unit_type_id:             number;
    /** Número de piezas. */
    number_pieces:            number;
    /** Peso bruto. */
    gross_weight:             number;
    /** Peso de tara. */
    tare_weight:              number;
    /** Peso neto. */
    net_weight:               number;
    /** Número de remisión. */
    referral_number:          number;
    /** Agente aduanal. */
    customs_agent:            string;
    /** Fecha de salida (ISO 8601). */
    departure_date:           string;
    /** Hora de salida. */
    departure_time:           string;
    /** Identificador del tipo de salida. */
    output_type_id:           number | string;
    /** Remisión. */
    remittance:               number;
    /** Factura. */
    bill:                     string;
    /** Muestras de preregistro. */
    pre_registration_samples: string;
    /** Fecha del movimiento (ISO 8601). */
    movement_date?:           string;
    /** Estatus del lote. */
    batch_status:             string;
}

/** Datos para actualizar una salida con su transporte y ticket de báscula. */
export interface SalidaUpdate {
    /** Identificador de la salida. */
    id?:                      number;
    /** Identificador de la opción de tipo de salida. */
    output_type_option_id:    number;
    /** Identificador del máster. */
    id_master:                string;
    /** Identificador del lote. */
    batch_id:                 number;
    /** Número de operación. */
    operation_number:         string;
    /** Clave del precinto. */
    precinct_key:             number;
    /** Número de liberación. */
    release_number:           string;
    /** Identificador del cliente. */
    customer_id:              number;
    /** Identificador de la razón social. */
    id_business_name:         number;
    /** Destino. */
    destination:              string;
    /** Barco asociado. */
    ship:                     string;
    /** Identificador del grupo de material. */
    material_group_id:        number;
    /** Identificador del material. */
    material_id:              number;
    /** Pedimento. */
    petition:                 number;
    /** Identificador de la ubicación. */
    location_id:              number;
    /** Identificador del empaque. */
    packing_id:               number;
    /** Observaciones. */
    observations:             string;
    /** Total de piezas. */
    total_number_pieces:      number;
    /** Tonelaje. */
    tonnage:                  number;
    /** Nombre del checador. */
    checker_name:             string;
    /** Nombre del operador. */
    operator_name:            string;
    /** Identificador del tipo de transporte. */
    transport_type_id:        number;
    /** Línea transportista. */
    transport_line:           string;
    /** Tablas/placas. */
    boards:                   string;
    /** Identificador del tipo de unidad. */
    unit_type_id:             number;
    /** Número de piezas. */
    number_pieces:            number;
    /** Peso bruto. */
    gross_weight:             number;
    /** Peso de tara. */
    tare_weight:              number;
    /** Peso neto. */
    net_weight:               number;
    /** Número de remisión. */
    referral_number:          number;
    /** Agente aduanal. */
    customs_agent:            string;
    /** Fecha de salida (ISO 8601). */
    departure_date:           string;
    /** Hora de salida. */
    departure_time:           string;
    /** Identificador del tipo de salida. */
    output_type_id:           number;
    /** Remisión. */
    remittance:               number;
    /** Factura. */
    bill:                     string;
    /** Muestras de preregistro. */
    pre_registration_samples: string;
    /** Clave/ruta del ticket de báscula. */
    weighbridge_ticket:       string;
    /** Clave/ruta de la orden de transporte. */
    transportation_order:     string;
}

/** Respuesta de error genérica con bandera y mensaje. */
export interface MessageError {
    /** Indica si la operación produjo error. */
    error:          boolean;
    /** Mensaje descriptivo del resultado. */
    message:        string;
}

/** Entrada (entry) de un lote con datos aduanales, de mercancía y ubicaciones. */
export interface Entry {
    /** Identificador de la entrada. */
    id?:                  number;
    /** Identificador del lote. */
    batch_id:             number;
    /** Identificador del tipo de entrada. */
    input_type_id:        number;
    /** Identificador del estatus del lote. */
    batch_status_id:      number;
    /** Número de operación. */
    operation_no:         number;
    /** Clave del precinto. */
    precinct_key:         number;
    /** Total de piezas. */
    total_pieces:         number;
    /** Tonelaje. */
    tonnage:              number | string;
    /** Identificador de la ubicación. */
    location_id:          number;
    /** Identificador del máster (puede ser nulo). */
    master_id:            null | string;
    /** Fecha de entrada (ISO 8601). */
    entry_date:           string;
    /** Agente aduanal. */
    customs_agent:        string;
    /** Condiciones de carga (puede ser nulo). */
    load_conditions:      null | string;
    /** Observaciones (puede ser nulo). */
    observations_1:       null | string;
    /** Número de barco (puede ser nulo). */
    boat_no:              number | null;
    /** Número de manifiesto (puede ser nulo). */
    manifest_no:          null | string;
    /** BL máster (puede ser nulo). */
    master_bl:            null | string;
    /** Secuencia de mercancía (puede ser nula). */
    merchandise_sequence: null | string;
    /** Descripción (puede ser nula). */
    description_1:        null | string;
    /** Tipo de moneda (puede ser nulo). */
    currency_type:        null | string;
    /** Valor (puede ser nulo). */
    value:                null | string;
    /** Unidad de medida del peso (puede ser nula). */
    ump:                  null | string;
    /** Volumen (puede ser nulo). */
    volume:               null | string;
    /** Unidad de medida del volumen (puede ser nula). */
    umv:                  null | string;
    /** Número de parcialidad (puede ser nulo). */
    partiality_no:        null | string;
    /** Unidad de medida comercial (puede ser nula). */
    umc:                  null | string;
    /** Identificador del usuario que crea el registro. */
    user_create_id?:       string,
    /** Identificador del usuario que actualiza el registro. */
    user_update_id?:       string,
    /** Lista de ubicaciones asociadas. */
    location_list:       LocationList[];
}

/** Ubicación dentro de una entrada/salida, con su tonelaje. */
export interface LocationList {
    /** Identificador del registro. */
    id:                 number;
    /** Identificador de la ubicación. */
    location_id:        number;
    /** Descripción corta de la ubicación. */
    short_description:  string;
    /** Tonelaje asignado a la ubicación. */
    tonnage:            number;
}

/** Entrada listada por lote con su tipo, tonelaje y estatus. */
export interface EntriesByBatch {
    /** Identificador de la entrada. */
    id:              number;
    /** Identificador del tipo de entrada. */
    input_type_id:   number;
    /** Descripción del tipo de entrada. */
    description:     string;
    /** Tonelaje. */
    tonnage:         string;
    /** Total de piezas. */
    total_pieces:    number;
    /** Fecha de entrada (ISO 8601). */
    entry_date:      string;
    /** Identificador del estatus del lote. */
    batch_status_id: number;
    /** Estatus de las ubicaciones. */
    locations_status:boolean;
}

/** Tipo de salida (output) con datos completos de transporte, pesaje, aduana y traspaso. */
export interface OutputType {
    /** Identificador de la salida. */
    id?:                                          number;
    /** Tipo de salida (texto auxiliar). */
    tipoSalida?:                                  string;
    /** Identificador de la opción de tipo de salida. */
    output_type_option_id:                        number | string;
    /** Identificador del lote. */
    batch_id:                                     number;
    /** Número de operación (puede ser nulo). */
    operation_number:                             number | null;
    /** Clave del precinto. */
    precinct_key:                                 number;
    /** Número de solicitud. */
    request_number:                               number | string;
    /** Clave de la solicitud. */
    key_request:                                  string;
    /** Fecha de salida (ISO 8601). */
    departure_date:                               string;
    /** Identificador del máster. */
    id_master:                                    string;
    /** Identificador del tipo de transporte. */
    transport_type_id:                            number;
    /** Identificador del remolque. */
    trailer_id:                                   number;
    /** Peso de origen. */
    origin_weight:                                number;
    /** Peso bruto. */
    gross_weight:                                 number;
    /** Peso de tara. */
    tare_weight:                                  number;
    /** Peso neto. */
    net_weight:                                   number;
    /** Peso de origen (segunda pesada). */
    origin_weight2:                               number;
    /** Peso bruto (segunda pesada). */
    gross_weight2:                                number;
    /** Peso de tara (segunda pesada). */
    tare_weight2:                                 number;
    /** Peso neto (segunda pesada). */
    net_weight2:                                  number;
    /** Total. */
    total:                                        number;
    /** Placa de la caja/van. */
    van_plate:                                    string;
    /** Placa de la caja/van (segunda pesada). */
    van_plate2:                                   string;
    /** Número de folio del ticket. */
    folio_ticket_number:                          string;
    /** Número de folio del ticket (segunda pesada). */
    folio_ticket_number2:                         string;
    /** Nombre del operador. */
    operator_name:                                string;
    /** Línea transportista. */
    transport_line:                               number;
    /** Remisión. */
    remittance:                                   string;
    /** Partes II. */
    parts_ii:                                     string;
    /** Unidad de medida comercial. */
    umc:                                          string;
    /** Unidad de medida del peso. */
    ump:                                          string;
    /** Número de integración. */
    integration_number:                           string;
    /** Agente aduanal. */
    customs_agent:                                string;
    /** Estatus de modulación. */
    modulation_status:                            string;
    /** Muestras de preregistro. */
    pre_registration_samples:                     string;
    /** Número de liberación. */
    release_number:                               string;
    /** Empresa de traspasos. */
    company_transfers:                            string;
    /** Fecha de traspaso (puede ser nula). */
    transfer_date:                                string | null;
    /** Clave del recinto destino. */
    key_destination_enclosure:                    number;
    /** Empresa que retorna. */
    returning_company:                            string;
    /** Domicilio de la empresa que retorna. */
    domicile_returning_company:                   string;
    /** Placa de la caja/van o número de barco. */
    plate_van_boat_number:                        string;
    /** Observaciones. */
    observations:                                 string;
    /** Identificador de la ubicación. */
    location_id:                                  number | string;
    /** Clave/ruta del ticket de báscula. */
    weighbridge_ticket:                           string;
    /** Clave/ruta de la orden de transporte. */
    transportation_order:                         string;
    /** Clave/ruta del documento de orden de traspaso. */
    transfer_order_document:                      string;
    /** Clave/ruta de la autorización oficial sin presentación física. */
    official_authorization_physical_presentation: string;
    /** Nombre del checador. */
    checker_name:                                 string;
    /** Descripción de la salida (texto auxiliar). */
    outputDescriptcion?:                          string;
    /** Total de piezas. */
    total_pieces:                                 number;
    /** Folio del traspaso. */
    transfer_folio?:                              string;
    /** Clave/ruta del documento de autorización de mermas. */
    autorization_losses_document?:                string;
    /** Clave/ruta del documento de mermas. */
    losses_file_document?:                        string;
    /** Identificador de la báscula de origen. */
    original_scale_id?:                           number;
    /** Lista de pesadas asociadas. */
    weight_list?:                                 any[];
    /** Lista de ubicaciones asociadas. */
    location_list:                                LocationList[];
    /** Placas. */
    plates?:                                      string;
    /** Fecha del documento de convenio aduanal (puede ser nula). */
    date_customs_agreement_document:              string | null;
}

/** Línea transportista con su identificador y descripción. */
export interface TranportLine {
    /** Identificador de la línea transportista. */
    id:          number;
    /** Descripción de la línea transportista. */
    description: string;
}

/** Pesada de transporte con pesos, piezas, placa y ticket. */
export interface Transport {
    /** Identificador de la lista de pesos. */
    id_weight_list:  number;
    /** Peso de origen. */
    origin_weight:   number;
    /** Peso bruto. */
    gross_weight:    number;
    /** Peso de tara. */
    tare_weight:     number;
    /** Peso neto. */
    net_weight:      number;
    /** Cantidad de piezas. */
    quantity_pieces: number;
    /** Placa del transporte. */
    plate:           string;
    /** Número de ticket. */
    no_ticket:       string;
}

/** Referencia a la URL del archivo de una pesada de transporte. */
export interface TransportFile {
    /** URL para acceder al archivo. */
    url:             string;
    /** Indica si la operación produjo error. */
    error:           boolean;
    /** Mensaje descriptivo del resultado. */
    message:         string;
}

/** Datos para crear una pesada de transporte. */
export interface TransportCreate {
    /** Identificador de la lista de pesos. */
    id_weight_list?: number;
    /** Identificador de la salida. */
    output_id:       number;
    /** Identificador del tipo de salida. */
    type_output_id:  number;
    /** Peso neto. */
    net_weight:      number;
    /** Peso bruto. */
    gross_weight:    number;
    /** Peso de tara. */
    tare_weight:     number;
    /** Cantidad de piezas. */
    quantity_pieces: number;
    /** Placa del transporte. */
    plate:           string;
    /** Número de ticket. */
    no_ticket:       string;
    /** Slabs asociadas (puede ser nulo). */
    no_slab:         any[] | null;
    /** Clave/ruta del archivo del ticket. */
    file_ticket:     string;
}

/** Pesada de transporte de exportación con pesos, piezas y entrada asociada. */
export interface ExportTransport {
    /** Identificador de la lista de pesos de exportación. */
    id_export_weight_list: number;
    /** Peso bruto. */
    gross_weight:          number;
    /** Peso de tara. */
    tare_weight:           number;
    /** Peso neto. */
    net_weight:            number;
    /** Cantidad de piezas. */
    quantity_pieces:       number;
    /** Placa del transporte. */
    plate:                 string;
    /** Número de ticket. */
    no_ticket:             string;
    /** Identificador de la entrada asociada. */
    entry_id:              number;
    /** Peso de origen. */
    origin_weight:         number;
}

/** Datos para crear una pesada de transporte de exportación o cabotaje. */
export interface ExportTransportCreate {
    /** Identificador de la lista de pesos de cabotaje. */
    id_cabotage_weight_list?:   number;
    /** Identificador de la lista de pesos de exportación. */
    id_export_weight_list?:     number;
    /** Identificador de la entrada asociada. */
    entry_id:                   number;
    /** Peso de origen. */
    origin_weight:              number;
    /** Peso bruto. */
    gross_weight:               number;
    /** Peso de tara. */
    tare_weight:                number;
    /** Cantidad de piezas. */
    quantity_pieces:            number;
    /** Placa del transporte. */
    plate:                      string;
    /** Número de ticket. */
    no_ticket:                  string;
    /** Clave/ruta del archivo del ticket. */
    file_ticket:                string;
}
